<template>
  <b-card>
    <div>
    </div>
    <b-tabs v-model="tabIndex">
      <b-tab>
        <template #title>
          <i class="far fa-clipboard-list fa-lg"></i>
          <i class="fa fa-circle fa-lg ml-2" style="color: #28a745"></i>
          {{$t('views.dashboard.dispatcher.tasks.assignedTasks') + ' ' + $t('views.dashboard.dispatcher.tasks.header') }}
        </template>
        <Table class="mt-2" :search-params="notAssignedSearchParams" v-if="tabIndex === 0"></Table>
      </b-tab>
      <b-tab >
        <template #title>
          <i class="far fa-clipboard-list fa-lg"></i>
          <i class="fa fa-circle fa-lg ml-2" style="color: #dc3545"></i>
          {{$t('views.dashboard.dispatcher.tasks.notAssignedTasks') + ' ' + $t('views.dashboard.dispatcher.tasks.header') }}
        </template>
        <Table class="mt-2" :display-assigned="false" :search-params="assignedSearchParams" v-if="tabIndex === 1"></Table>
      </b-tab>
    </b-tabs>
  </b-card>
</template>

<script>
import Table from '../../excmtask/Table'

export default {
  name: 'DispatcherTasks',
  components: {
    Table
  },

  data () {
    return {
      assignedSearchParams: {
        'lastPoolTask.operation': 0,
        'order[id]': 'desc',
        finished: 0
      },
      notAssignedSearchParams: {
        'lastPoolTask.operation': [1, 2, 3],
        'order[id]': 'desc',
        finished: 0
      },
      tabIndex: 0
    }
  }
}
</script>
